import styled from 'styled-components';

const Container = styled.div`
  .custom-accordion-panel-header {
    justify-content: space-between;
    flex-direction: row;
    display: flex;

    &:focus {
      outline: none;
    }

    img {
      width: 10px;
      margin-bottom: 0;
    }
  }

  a,
  button {
    width: 100%;
    margin-top: 20px;
  }

  .custom-accordion-panel-content {
    margin-top: 30px;
    transition: all 1s ease-in-out;
  }

  .custom-accordion-panel {
    margin-bottom: 20px;
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;

    &.active {
      box-shadow: 0px 15px 40px rgba(11, 26, 33, 0.1);
    }
    &.inactive {
      box-shadow: 0px 3px 10px rgba(11, 26, 33, 0.08);
    }
  }

  .rc-collapse {
    background: white;
    border: none;
  }

  p {
    text-align: left;
  }

  h3 {
    font-size: 20px;
    margin: 0;
  }

  img {
    width: 100%;
    margin-bottom: 30px;
  }
`;

const Panel = styled.div`
  transition: all 1s ease-in-out;
  .active {
    display: block;
  }

  .inactive {
    display: none;
  }
`;

export { Container, Panel };
